import { color } from 'd3-color';
import styled from 'styled-components';

interface Props {
  width: number;
  height: number;
  x: number;
  y: number;
  rx: number;
  ry: number;
  fill: string;
  hoverFill?: string;
  activeFill?: string;
  fillPattern: string;
  onClick: () => void;
}

interface FillProps {
  defaultFill: string;
  hoverFill?: string;
  activeFill?: string;
}

const Root = styled.g`
  .upright-rect {
    fill: ${(props: FillProps) => props.defaultFill};
    /* TODO OA TODO JO: Figure out a way to have the transition here without the
    colors flickering when adding/removing stuff to comparison */
  }
  &:hover {
    .upright-rect {
      transition: fill 0.15s ease-in-out;
      fill: ${(props: FillProps) => props.hoverFill};
    }
  }
  &:active {
    .upright-rect {
      fill: ${(props: FillProps) => props.activeFill};
    }
  }
`;

export function RectWithFillPattern(props: Props) {
  const { width, height, x, y, fillPattern, rx, ry } = props;

  const baseColor = color(props.fill)!;
  const hoverFill = props.hoverFill || baseColor.darker(0.5).hex();
  const activeFill = props.activeFill || baseColor.darker(0.7).hex();

  return (
    <Root defaultFill={props.fill} hoverFill={hoverFill} activeFill={activeFill}>
      <rect className="upright-rect" width={width} height={height} x={x} y={y} rx={rx} ry={ry} />
      <rect onClick={props.onClick} width={width} height={height} x={x} y={y} fill={fillPattern} rx={rx} ry={ry} />
    </Root>
  );
}
